import { memo, useState } from 'react';
import { IImages } from '../../mechanics/characters/Character';
import { uiSlice } from '../../store/reducers/uiReducer';
import { useAppDispatch } from '../../store/store';
import ImgWithFallback from '../ui/ImgWithFallback';
import ToolTip from '../ui/ToolTip';

interface ICharacterRaceProps {
    CharacterClass: IImages,
    switchClass: () => void,
    activeClassName: string,
    classTip: string
}

const CreateCharacterClass = ({ CharacterClass, switchClass, activeClassName, classTip }: ICharacterRaceProps) => {
    const dispatch = useAppDispatch()
    const { setToolTipContent } = uiSlice.actions
    const [toolTip, setToolTip] = useState(false)

    function callToolTip(tipType: string) {
        setToolTip(true)
        dispatch(setToolTipContent(tipType))
    }

    return (
        <div className={`create-character__class-variable ${activeClassName}`} onClick={switchClass} onMouseEnter={() => callToolTip(classTip)} onMouseLeave={() => setToolTip(false)}>
            <ImgWithFallback
                src={CharacterClass.webp}
                fallbackSrc={CharacterClass.img} />
            {toolTip ? <ToolTip position='bottom' text={classTip} /> : null}
        </div>
    );
};

export default memo(CreateCharacterClass);